<template>
  <div class="sticky-parent">
    <div class="sticky-child">
      <DatabaseHeader />
      <NavTabDynamic
        class="navtab"
        :active="currentSubType"
        @redirectInput="redirectTab"
      />
    </div>
    <DatabaseContent />
  </div>
</template>

<script>
import DatabaseHeader from '@/components/Database/Header/DatabaseHeader.vue';
import NavTabDynamic from '@/components/Main/TheNavTabDynamic.vue';
import DatabaseContent from '@/components/Database/DatabaseContent/DatabaseContent.vue';
import { mapState, mapMutations, mapActions } from 'vuex';

export default {
  components: {
    DatabaseHeader,
    NavTabDynamic,
    DatabaseContent,
  },
  computed: {
    ...mapState('databaseState/detail', ['currentSubType']),
  },
  methods: {
    ...mapMutations('databaseState/detail', ['setCurrentSubType']),
    redirectTab(item) {
      this.setCurrentSubType(item);
    },
  },
};
</script>

<style lang="scss" scoped>
.database-navtab {
  grid-area: tab;
}
/*.wrapper {
  width: 100%;
  margin-top: 0rem;
}*/
/*.database-header {
  margin-top: 1rem;
  position: sticky;
  top: 3.5rem;
  z-index: 97;
  background-color: $bg-primary;
  width: 100%;
}*/
.sticky-parent {
  overflow: visible;
}
.sticky-child {
  position: sticky;
  top: 3.5rem;
  z-index: 1;
  background-color: $bg-primary;
}
</style>
